/* eslint-disable */
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import "./App.css";
import randomString from "random-string";
import RoomClient from "../../qrtc_web_sdk/RoomClient100";
import {
  QRTCParams,
  QRTCVideoResolution,
  QRTCVideoResolutionMode,
  QRTCVideoStreamType,
  QRTCVideoEncParams,
  QRTCMediaDeviceChangeEvent,
  QRTCMediaDeviceInfo,
  QRTCCodecType
} from "../../qrtc_web_sdk/RoomParams";
import {RTCError} from "../../qrtc_web_sdk/RoomErrors"
import QRTCVideoView from "../../component/QRTCVideoView";
import { WSSSERVER } from "@/config/const";

const maxWidth = 800;
//样式
const MainWindowDiv = styled.div`
width: 100%;
height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  background: yellow;
  @media (max-width: ${maxWidth}px) {
    background: #F1F1F1;
  }
`;

const TopHeader = styled.div`
   width: 100%;
   height: 40px;
   display: flex;
   flex-direction: row;
   background: #F1F1F1;
`;

const MiddleContent = styled.div`
   width: 100%;
   display: flex;
   flex: 1;
   flex-direction: row;
   @media (max-width: ${maxWidth}px) {
    flex-direction: column;
  }
   background: black;
`;

const MiddleContent_Left = styled.div`
width: 85%;
@media (max-width: ${maxWidth}px) {
  width: 100%;
  height:70%;
}
display: flex;
background: dark;
justify-content: center;
`;

const MiddleContent_Right = styled.div`
width: 15%;
height:calc(100vh - 100px);
flex-direction: column;
overflow-y: auto;
overflow-x: hidden;
align-items: center;
@media (max-width: ${maxWidth}px) {
  width: 100%;
  height:30%;
  flex-direction: row;
  overflow-y: hidden;
overflow-x: auto;
justify-content: center;
}
display: flex;
background: #F1F1F1;
`;

const BottomBar = styled.div`
   width: 100%;
   height: 60px;
   display: flex;
   flex-direction: row;
   background: #F1F1F1;
`;

let roomClient: RoomClient;
// type RoomUser = {
//   peerId?: string;
//   peerName?: string;
//   userVideoDom:any;
//   userAudioDom:any;
// };

function App() {
  const peerId = randomString({ length: 8 }).toLowerCase();

  // const roomUsers:Map<string,RoomUser>=new Map([
  //   [peerId,{
  //     userVideoDom:useRef(),
  //     userAudioDom:useRef(),
  //   }],
  // ]);

  const usersRef = useRef({
    //白板DOM
    whiteBoardDom: React.createRef<HTMLVideoElement>(),
    //人员列表, 包含自己
    peers: [
      {
        peerId: peerId,
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
      {
        peerId: "",
        peerName: "peerName",
        userVideoDom: React.createRef<HTMLVideoElement>(),
        userAudioDom: React.createRef<HTMLAudioElement>(),
      },
    ],
  });
  //如果固定窗口,我没必要重新渲染了
  //const [userList,setUserList]=React.useState([...usersRef.current.values()]);
  //当前的一个索引值

  //console.log(setUsers);

  useEffect(() => {
    //初始化qrtc sdk
    enterRoom();

    return () => {
      //clean up qrtc sdk
      roomClient.close();
    };
  }, []);

  async function enterRoom() {
    roomClient = new RoomClient();
    //let beautyManager = roomClient.getBeautyManager();
    //beautyManager.setProductIndex(0);
    //已进入房间
    roomClient.on("enterRoom", async () => {
      //此处进行状态清理
      console.log(`[APP] enterRoom!`);
      for (var i = 0; i < usersRef.current.peers.length; i++) {
        if (i > 0) {
          usersRef.current.peers[i].peerId = "";
          usersRef.current.peers[i].peerName = "";
          (usersRef.current.peers[i].userVideoDom.current as any).srcObject =
            null;
          (usersRef.current.peers[i].userAudioDom.current as any).srcObject =
            null;
          //清理白板(后面可能还要自动去分享之前的内容)
          (usersRef.current.whiteBoardDom.current as any).srcObject = null;
        }
      }
      // await roomClient.startLocalPreview(
      //   usersRef.current.peers[0].userVideoDom.current
      // );
      await roomClient.startLocalAudio(false);
    });
    //已离开房间
    roomClient.on("exitRoom", async () => {});

    //与服务器的连接断开
    roomClient.on("connectionLost", () => {
      console.log("[App] connectionLost");
    });

    //有人加入房间
    roomClient.on("remoteUserEnterRoom", (userInfo) => {
      console.log("[App] userEnterRoom:" + JSON.stringify(userInfo));
      let position = getRemoteViewPosition(userInfo.userId);
    });

    //有人离开房间
    roomClient.on("remoteUserLeaveRoom", (userInfo) => {
      console.log("[App] userLeaveRoom:" + JSON.stringify(userInfo));
      let find_result = usersRef.current.peers.findIndex(
        (obj) => obj.peerId == userInfo.userId
      );
      usersRef.current.peers[find_result].peerId = "";
      (
        usersRef.current.peers[find_result].userVideoDom.current as any
      ).srcObject = null;
    });

    //有人开始推视频流
    roomClient.on("userVideoAvailable", async (videoInfo) => {
      console.log(
        `[App] userVideoAvailable videoInfo=${JSON.stringify(videoInfo)}`
      );
      const { userId, available } = videoInfo;

      let position = findRemoteViewByUserId(userId);
      if (position < 1) {
        console.log(
          `[App] userVideoAvailable findRemoteViewByUserId:${userId} failed!!!!`
        );
        return;
      }
      if (available) {
        await roomClient.startRemoteVideo(
          userId,
          usersRef.current.peers[position].userVideoDom.current
        );
      } else {
        //需要刷新一下对应的video控件
        //如果没有离开的话，就不需要刷新
        //usersRef.current.peers[position].peerId='';
        (
          usersRef.current.peers[position].userVideoDom.current as any
        ).srcObject = null;
      }
    });
    //有人开始推音频流
    roomClient.on("userAudioAvailable", async (audioInfo) => {
      console.log(
        `[userAudioAvailable] audioInfo=${JSON.stringify(audioInfo)}`
      );
      const { userId, available } = audioInfo;
      let position = findRemoteViewByUserId(userId);
      console.log(`[App] userAudioAvailable position=${position}`);
      if (position < 1) {
        return;
      }
      if (available) {
        await roomClient.startRemoteAudio(
          userId,
          usersRef.current.peers[position].userAudioDom.current
        );
      } else {
        //需要刷新一下对应的video控件
      }
    });
    //有人开始推桌面共享流
    roomClient.on("userShareAvailable", async (shareInfo) => {
      console.log(`[App] userShareAvailable videoInfo=${shareInfo}`);
      const { userId, available } = shareInfo;
      if (available) {
        await roomClient.startRemoteShare(
          userId,
          usersRef.current.whiteBoardDom.current
        );
      } else {
        //需要刷新一下对应的video控件
      }
    });

    //我自己的桌面共享开始了
    roomClient.on("screenCaptureStarted", () => {});

    //我自己的桌面共享暂停了
    roomClient.on("screenCapturePaused", () => {});

    //我自己的桌面共享继续了
    roomClient.on("screenCaptureResumed", () => {});

    //我自己的桌面共享停止了
    roomClient.on("screenCaptureStoped", () => {});

    //用于提示音量大小的回调，包括每个 userId 的音量和远端总音量 如果没有人说话，则 userVolumes 为空，totalVolume 为0。
    //userVolumes	所有正在说话的房间成员的音量，取值范围0 - 100。
    //totalVolume	所有远端成员的总音量, 取值范围0 - 100。
    //userId 为 nil 时表示自己的音量，userVolumes 内仅包含正在说话（音量不为0）的用户音量信息。
    roomClient.on("userVoiceVolume", (volumeInfo) => {
      //console.log(`[App] userVoiceVolume userVolumeArray:${JSON.stringify(volumeInfo.userVolumes)} totalVolume:${volumeInfo.totalVolume} `)
    });

    roomClient.on("deviceChanged", (deviceEvent) => {
      switch (deviceEvent.event) {
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_WebCamAdded:
          console.log(`[App] 新插入的摄像头 id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_WebCamRemoved:
          console.log(`[App] 有摄像头被拔出 id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicAdded:
          console.log(`[App] 新插入的麦克风 id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicRemoved:
          console.log(`[App] 有麦克风被拔出 id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_SpeakerAdded:
          console.log(`[App] 新插入扬声器 id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_SpeakerRemoved:
          console.log(`[App] 有扬声器被拔出 id=${deviceEvent.deviceId}`);
          break;
        default:
          break;
      }
    });

    roomClient.on("networkQuality", (qualityInfo) => {
      console.log(`[APP] networkQuality=${JSON.stringify(qualityInfo)}`);
    });

    roomClient.on("mute-audio", () => {});

    roomClient.on("mute-video", () => {});

    roomClient.on("unmute-audio", () => {});

    roomClient.on("unmute-video", () => {});

    roomClient.on("connection-state-changed", (event) => {
      //const prevState = event.prevState;
      //const curState = event.state;
    });

    console.log("join room success");
    try {
      //await roomClient.join()
      let roomId = "12345";
      let roomInfo: QRTCParams = {
        serverUrl: WSSSERVER,//`wss://superrtc.com/websocket/`, 
        sdkAppId: 1,
        userSig: "",
        userId: `${roomId}_${randomString({ length: 8 }).toLowerCase()}`,
        userName: "pcgweb",
        roomId,
        maxRetryTime: 10 * 1000,
      };
      //设置默认编码参数
      let encoderParams: QRTCVideoEncParams = {
        preferCodec: QRTCCodecType.QRTCCodec_H264Base,
        videoResolution: QRTCVideoResolution.QRTCVideoResolution_480_360,
        resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
        videoFps: 15,
        minVideoBitrate: 200,
        maxVideoBitrate: 500,
      };
      roomClient.setVideoEncoderParam(encoderParams);
      if (roomClient.enableEncSmallVideoStream(true) < 0) {
        //当前设置的分辨率无法开启大小流模式
      }
      await roomClient.enterRoom(roomInfo);
      await roomClient.getCameraDeviceList();
    } catch (e) {
      console.error("join room failed! " + e);
    }

    console.log("join room success");
  }

  async function openShare() {
    console.log("opening share!");
    let encParams: QRTCVideoEncParams = {
      preferCodec: QRTCCodecType.QRTCCodec_H264Base,
      videoResolution: QRTCVideoResolution.QRTCVideoResolution_1280_720,
      resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
      videoFps: 12,
      minVideoBitrate: 300,
      maxVideoBitrate: 1200,
    };
    roomClient.startScreenCapture(
      encParams
    );
  }

  async function stopLocalPreview() {
    await roomClient.stopLocalPreview();
    //await roomClient.stopLocalPreviewOnly();
  }
  async function startLocalPreview() {
    let cameraList:any = await roomClient.getCameraDeviceList();
    console.log(cameraList);
    try{
      //await roomClient.startLocalPreviewOnly(1280,720,"f90e2c1d29ed292ce0d8cc15d6233ca563aa0f0480565df74b1ed280f58552f3",usersRef.current.peers[0].userVideoDom.current);
      await roomClient.startLocalPreview(usersRef.current.peers[0].userVideoDom.current);
    }catch(error){
      if(error instanceof RTCError){
        //error.errorCode and error.message
      }
    }
    
  }

  async function startLocalPreviewWithSVC() {
    let encoderParams: QRTCVideoEncParams = {
      preferCodec: QRTCCodecType.QRTCCodec_VP9,
      videoResolution: QRTCVideoResolution.QRTCVideoResolution_1920_1080,
      resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
      videoFps: 15,
      minVideoBitrate: 2000,
      maxVideoBitrate: 5000,
    };
   roomClient.setVideoEncoderParam(encoderParams)
   roomClient.enableEncSmallVideoStream(true);
   await roomClient.startLocalPreview(usersRef.current.peers[0].userVideoDom.current);
  }

  async function stopLocalPreviewWithSVC() {
    await roomClient.stopLocalPreview();
  }
/*
Simulcast是一种视频编码技术，它允许发送者同时发送多个空间和/或时间上的不同版本的同一视频流。
这些版本可以有不同的分辨率、帧率和质量。接收者可以根据其网络条件、设备性能和显示大小选择最适合的流进行接收和解码。
*/ 
  async function startLocalPreviewWithSimulcast() {
    let encoderParams: QRTCVideoEncParams = {
      preferCodec: QRTCCodecType.QRTCCodec_H264Base,
      videoResolution: QRTCVideoResolution.QRTCVideoResolution_1280_720,
      resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
      videoFps: 15,
      minVideoBitrate: 2000,
      maxVideoBitrate: 5000,
    };
    roomClient.setVideoEncoderParam(encoderParams)
    roomClient.enableEncSmallVideoStream(true);
    // 这行代码启用了小视频流，这是Simulcast的一部分。这意味着除了主视频流外，还会发送一个分辨率较低的小视频流。这对于在网络条件较差或设备性能较低的情况下保持视频通话的流畅性非常有用。
   await roomClient.startLocalPreview(usersRef.current.peers[0].userVideoDom.current);
  }

  async function stopLocalPreviewWithSimulcast() {
    await roomClient.stopLocalPreview();
  }

  async function stopLocalAudio() {
    roomClient.stopLocalAudio();
  }

  async function startLocalAudio() {
    roomClient.startLocalAudio(false);
  }

  async function muteLocalAudio() {
    roomClient.muteLocalAudio(true);
  }

  async function unMuteLocalAudio() {
    roomClient.muteLocalAudio(false);
  }

  async function muteAllRemoteAudios() {
    await roomClient.muteAllRemoteAudios(true);
  }

  async function unMuteAllRemoteAudios() {
    await roomClient.muteAllRemoteAudios(false);
  }

  async function muteAllRemoteViews() {
    await roomClient.muteAllRemoteViews(true);
  }

  async function unMuteAllRemoteViews() {
    await roomClient.muteAllRemoteViews(false);
  }

  async function setMcuLayout() {
    //await roomClient.setMcuLayout()
    await roomClient.getCameraDeviceList();
    await roomClient.setCurrentCameraDevice("123");
  }

  async function logReportToServer() {
    var dateTime = new Date();
    var lastDateTimeTmp = dateTime.setDate(dateTime.getDate() - 1);
    let lastDateTime = new Date(lastDateTimeTmp);
  }

  function getRemoteViewPosition(userId: string) {
    //只要来了新用户,就必然要找个空的位置给他
    let find_empty_result = usersRef.current.peers.findIndex(
      (value) => value.peerId === ""
    );
    console.log(
      `[APP] getRemoteViewPosition find_empty_result = ${find_empty_result}`
    );
    usersRef.current.peers[find_empty_result].peerId = userId;
    console.log(`[APP] 5678 ${usersRef.current.peers[1].peerId}`);
    return find_empty_result;
  }

  function findRemoteViewByUserId(userId: string) {
    let find_peer_result = usersRef.current.peers.findIndex(
      (obj) => obj.peerId === userId
    );
    console.log(
      `[APP] findRemoteViewByUserId userId = ${userId} find_peer_result = ${find_peer_result}`
    );
    console.log(`[APP] 1234 ${usersRef.current.peers[1].peerId}`);
    return find_peer_result;
  }

  function switchStream(userIndex: number, type: QRTCVideoStreamType) {
    //let beautyManager = roomClient.getBeautyManager();
    //beautyManager.setWhitenessLevel(10);
    //beautyManager.setFaceSlimLevel(10);
    //test onfly bandwith setting
    // roomClient.onFlyBandWidth();
    // let userId = usersRef.current.peers[userIndex].peerId;
    // console.log(`[App] switchStream userId=${userId}`);
    // roomClient.setRemoteVideoStreamType(userId, type);
  }

  return (
    <MainWindowDiv>
      <TopHeader>
        <button type="button" onClick={openShare}>
          桌面共享
        </button>
        <button type="button" onClick={stopLocalPreview}>
          关闭本地视频
        </button>
        <button type="button" onClick={startLocalPreview}>
          打开本地视频
        </button>
        <button type="button" onClick={startLocalPreviewWithSVC}>
          打开svc推流
        </button>
        <button type="button" onClick={stopLocalPreviewWithSVC}>
          关闭svc推流
        </button>
        <button type="button" onClick={startLocalPreviewWithSimulcast}>
          打开simu推流
        </button>
        <button type="button" onClick={stopLocalPreviewWithSimulcast}>
          关闭simu推流
        </button>
        <button type="button" onClick={stopLocalAudio}>
          关闭本地音频
        </button>
        <button type="button" onClick={startLocalAudio}>
          打开本地音频
        </button>
        <button type="button" onClick={muteLocalAudio}>
          暂停本地音频
        </button>
        <button type="button" onClick={unMuteLocalAudio}>
          恢复本地音频
        </button>
        <button type="button" onClick={muteLocalAudio}>
          暂停本地音频
        </button>
        <button type="button" onClick={unMuteLocalAudio}>
          恢复本地音频
        </button>
        <button type="button" onClick={setMcuLayout}>
          MCULayout
        </button>
        <button type="button" onClick={logReportToServer}>
          日志上报
        </button>
        </TopHeader>
        <MiddleContent>
        <MiddleContent_Left>
        <video
            ref={usersRef.current.whiteBoardDom}
            autoPlay
            muted
            controls={false}
          />
        </MiddleContent_Left>
       <MiddleContent_Right>
       {usersRef.current.peers.map((item, index) => {
            return (
              <QRTCVideoView
                userIndex={index}
                userVideoDom={item.userVideoDom}
                userAudioDom={item.userAudioDom}
                switchStream={switchStream}
              />
            );
          })}
       </MiddleContent_Right>
        </MiddleContent>
        <BottomBar>
          <p>bottomBar</p>
        </BottomBar>
    </MainWindowDiv>
  );
}

export default App;
